export const data = () => ({
  isDebug: true,
  loading: false,
  frequentlyAskedQuestionID: 0,
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
